import moment from "moment";
import { axiosGet, axiosPost } from "../../apis/useAxios";

// Crew Feedback › Feedback. Only this page's own API (feedback/*).

const airlineCode = () => sessionStorage.getItem("session_airlineCode") ?? "";
const userName = () => sessionStorage.getItem("session_userName") ?? "";

const failed = (response) => !response || (response.isSuccess === false && !/no record/i.test(response.message ?? ""));

/** The airline's feedback, newest first: sent from `from` to `to` (Date, whole days), of one crew member, or both. */
export async function getFeedbacks({ from, to, employeeNumber }, options) {
  const params = { airlineCode: airlineCode() };
  if (from && to) {
    params.from = moment(from).format("YYYY-MM-DD");
    params.to = moment(to).format("YYYY-MM-DD");
  }
  if (employeeNumber) params.employeeNumber = employeeNumber;
  const response = await axiosGet("feedback/list", params, options);
  if (failed(response)) throw new Error(response?.message || "Unable to load the feedback.");
  return response.payload ?? [];
}

/** One feedback with its details, photo URLs and thread. */
export async function getFeedbackDetail(id, options) {
  const response = await axiosGet("feedback/detail", { airlineCode: airlineCode(), id }, options);
  if (!response || response.isSuccess === false || !response.payload) {
    throw new Error(response?.message || "Unable to load the feedback.");
  }
  return response.payload;
}

/** Saves the reply and the new status; the crew member sees both in the crew app. */
export function replyToFeedback({ id, replyMsg, issueStatusId }) {
  return axiosPost("feedback/reply", { airlineCode: airlineCode(), userName: userName(), id, replyMsg, issueStatusId });
}
